import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';
import { CoreModule } from '../core/core.module';
import { DynamicFieldDirective } from './components/dynamic-field/dynamic-field.directive';
import { FormInputComponent } from './components/form-input/form-input.component';
import { HeaderLabelComponent } from './components/header-label/header-label.component';
import { LabelComponent } from './components/label/label.component';
import { DynamicFormComponent } from './containers/dynamic-form/dynamic-form.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, EditorModule, CoreModule],
  declarations: [
    DynamicFieldDirective,
    DynamicFormComponent,
    FormInputComponent,
    HeaderLabelComponent,
    LabelComponent,
  ],
  exports: [DynamicFormComponent],
  entryComponents: [FormInputComponent, HeaderLabelComponent, LabelComponent],
})
export class DynamicFormModule {}
